import React, { useEffect, useRef, useState } from "react";
import { classes } from "../../../core/data/json/classes";
import Table from "../../../core/common/dataTable/index";
import PredefinedDateRanges from "../../../core/common/datePicker";
import {
  activeList,
  classSection,
  classSylabus,
} from "../../../core/common/selectoption/selectoption";
import CommonSelect from "../../../core/common/commonSelect";
import { Link, useLocation, useParams } from "react-router-dom";
import TooltipOption from "../../../core/common/tooltipOption";
import { all_routes } from "../../router/all_routes";
import UserService from "../../network/services/UserService";
import { getUser } from "../../network/auth/Auth";
import { Modal, Toast } from "react-bootstrap";
import "./application.css"
import { DatePicker } from "antd";

const Application = () => {
  const routes = all_routes;
  const location = useLocation()
  const data = classes;
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove("show");
    }
  };
  const route = all_routes
  const { id } = useParams();
  const admissionId = id;


  interface AdmissionData {
    id: any;
    name: any;
    application_number: any;
    state: any;
    admission_date: false,
    application_date: any;
    student_id: any;
    register_id: any;
    course_id: any;

  }
  interface Option {
    id: any;
    name: any;
  }



  interface CourseData {
    id: any;
    name: any;
    code: any;
    parent_id: any;
    evaluation_type: any;
    subject_ids: any;
    department_id: any;
    active: any;
    fees_term_id: any;
    operating_branch_id: any;
    company_id: any

  }

  interface AcademyYearData {
    id: any;
    name: any;
    start_date: any;
    end_date: any;
    academic_term_ids: any;
    term_structure: any;
    company_id: any;
  }
  interface CourseFeesData {
    id: any;
    name: any;
    standard_price: any;
    lst_price: any;
    detailed_type: any,
    company_id: any

  }

  interface AcademyTermData {
    id: any;
    name: any;
    term_start_date: any;
    term_end_date: any;
    academic_term_ids: any;
    term_structure: any;
    company_id: any;

  }

  interface OptionType {
    id: any;
    name: any;
  }


  const [isActionSuccessful, setIsActionSuccessful] = useState(false);
  const [isActionSuccessfulEdit, setIsActionSuccessfulEdit] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showDangerToast, setShowDangerToast] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState<any>({
    name: '',
    start_date: '',
    end_date: '',
    course_id: '',
    product_id: '',
    min_count: '',
    max_count: '',
    academic_years_id: '',
    academic_term_id: '',
    minimum_age_criteria: '',
    operating_branch_id: '',
    company_id: ''
  });




  const handleSuccessToastClose = () => {
    setShowSuccessToast(false);
  };

  const handleDangerToastClose = () => {
    setShowDangerToast(false);
  };

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const handleClose2 = () => setShowModal2(false);
  const handleShow2 = () => setShowModal2(true);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowDangerToast(false);
    }, 3000);
    return () => clearTimeout(timeoutId);
  }, [showDangerToast]);


  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowSuccessToast(false);
    }, 4000);
    return () => clearTimeout(timeoutId);
  }, [showSuccessToast]);

  const [formData, setFormData] = useState({
    name: '',
    start_date: '',
    end_date: '',
    course_id: '',
    product_id: '',
    min_count: '',
    max_count: '',
    academic_years_id: '',
    academic_term_id: '',
    minimum_age_criteria: '',
    operating_branch_id: '',
    company_id: ''
  });

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });


    console.log(value);
    fetchDataOpBatchs(value)
  };

  const handleInputChangeEdite = (e: any) => {
    const { name, value } = e.target;
    setSelectedRecord((prevRecord: any) => ({
      ...prevRecord,
      [name]: value
    }));
  };

  const handleInputChangeEdite2 = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const { value } = event.target;
    const selectedBranch = branches.find((branch: any) => branch.id === parseInt(value, 10));

    if (selectedBranch) {
      setSelectedRecord((prevState: any) => ({
        ...prevState,
        operating_branch_id: [selectedBranch],
      }));
    }
  };

  const handleInputChangeEdite3 = (selectedOptions: any) => {
    if (selectedOptions) {
      const selectedSubjects = selectedOptions.map((option: any) => ({
        id: option.value,
        name: option.label,
      }));

      setSelectedRecord((prevState: any) => ({
        ...prevState,
        subject_ids: selectedSubjects,
      }));
    } else {
      setSelectedRecord((prevState: any) => ({
        ...prevState,
        subject_ids: [],
      }));
    }
  };



  const handleSelectChange = (selectedOption: any, actionMeta: any) => {

    setFormData({
      ...formData,
      [actionMeta.name]: selectedOption
    });
  };


  const [multiSubject, setMultiSubject] = useState<OptionType[]>([]);

  const handleEdit = (record: any) => {
    setSelectedRecord(record)
    handleShow2()
    console.log(record)

  };




  /*   const handleSubmit = () => {
      setIsLoading(true)
  
      const request_data = {
        name: formData.name,
        start_date: formData.start_date,
        end_date: formData.end_date,
        min_count: parseInt(formData.min_count, 10),
        max_count: parseInt(formData.max_count, 10),
        academic_years_id: parseInt(formData.academic_years_id, 10),
        academic_term_id: parseInt(formData.academic_term_id, 10),
        minimum_age_criteria: parseInt(formData.minimum_age_criteria, 10),
        course_id: parseInt(formData.course_id, 10),
        product_id: parseInt(formData.product_id, 10),
        company_id: getUser()?.company_ids[0]?.id,
        operating_branch_id: formData.operating_branch_id === "" ? getUser()?.company_ids[0]?.branches[0]?.id : parseInt(formData.operating_branch_id, 10),
      };
  
      UserService.addAdmission(request_data, (response: any) => {
        if (response.data && response.success) {
          fetchData(getUser()?.company_ids[0]?.branches[0]?.id, getUser()?.company_ids[0]?.id, branch);
          setIsLoading(false)
          setIsActionSuccessful(true)
          setSuccessMessage('Data saved successfully')
          setShowSuccessToast(true)
          setFormData({
            name: '',
            start_date: '',
            end_date: '',
            course_id: '',
            product_id: '',
            min_count: '',
            max_count: '',
            academic_years_id: '',
            academic_term_id: '',
            minimum_age_criteria: '',
            operating_branch_id: '',
            company_id: ''
          });
  
          setShowModal(false);
  
        } else {
          setErrorMessage('An error has occurred, please try again.')
          setShowDangerToast(true)
          setIsLoading(false)
        }
      });
    }; */

  /*   const handleSubmitEdit = () => {
  
  
      setIsLoading(true)
      const request_data = {
        name: selectedRecord.name,
        start_date: selectedRecord.start_date,
        end_date: selectedRecord.end_date,
        min_count: parseInt(selectedRecord.min_count, 10),
        max_count: parseInt(selectedRecord.max_count, 10),
        academic_years_id: Array.isArray(selectedRecord.academic_years_id) ? parseInt(selectedRecord.academic_years_id[0].id, 10) : parseInt(selectedRecord.course_id, 10),
        academic_term_id: Array.isArray(selectedRecord.academic_term_id) ? parseInt(selectedRecord.academic_term_id[0].id, 10) : parseInt(selectedRecord.course_id, 10),
        minimum_age_criteria: parseInt(selectedRecord.minimum_age_criteria, 10),
        course_id: Array.isArray(selectedRecord.course_id) ? parseInt(selectedRecord.course_id[0].id, 10) : parseInt(selectedRecord.course_id, 10),
        product_id: Array.isArray(selectedRecord.product_id) ? parseInt(selectedRecord.product_id[0].id, 10) : parseInt(selectedRecord.product_id, 10),
        company_id: getUser()?.company_ids[0]?.id,
        operating_branch_id: selectedRecord?.operating_branch_id?.[0]?.id === undefined ? parseInt(selectedRecord?.operating_branch_id?.[0]?.id, 10) : parseInt(selectedRecord?.operating_branch_id?.[0]?.id, 10),
      };
      console.log(request_data)
      console.log(selectedRecord)
  
  
      UserService.editAdmission(selectedRecord?.id, request_data, (response: any) => {
        if (response.data && response.success) {
          fetchData(getUser()?.company_ids[0]?.branches[0]?.id, getUser()?.company_ids[0]?.id, branch);
          setIsLoading(false)
          setIsActionSuccessfulEdit(true)
  
          setFormData({
            name: '',
            start_date: '',
            end_date: '',
            product_id: '',
            course_id: '',
            min_count: '',
            max_count: '',
            academic_years_id: '',
            academic_term_id: '',
            minimum_age_criteria: '',
            operating_branch_id: '',
            company_id: ''
          });
          handleClose2()
        } else {
  
          setErrorMessage('An error has occurred, please try again.')
          setShowDangerToast(true)
          setIsLoading(false)
        }
      });
    }; */

  const formatDate = (date: Date | string) => {
    if (!date) return '';

    const d = new Date(date);
    const month = `${d.getMonth() + 1}`.padStart(2, '0');
    const day = `${d.getDate()}`.padStart(2, '0');
    const year = d.getFullYear();

    return `${year}-${month}-${day}`;
  };




  interface PartnerTitleData {
    id: any;
    name: any;
    shortcut: any;
  }


  interface OpFeesTermData {
    id: any;
    name: any;
  }

  interface OpBatchData {
    id: any;
    name: any;
  }

  interface AdmissionData2 {
    name: any,
    state: any,
    start_date: any,
    end_date: any,
    max_count: any,
    min_count: any,
    product_id: any,
    company_id: any,
    course_id: any,
    minimum_age_criteria: any,
    operating_branch_id: any,
    academic_term_id: any,
    academic_years_id: any,
  }


  const [Admissions, setAdmissions] = useState<AdmissionData[]>([]);
  const [admission, setAdmission] = useState<AdmissionData2>();
  const [partnerTitle, setPartnerTitle] = useState<PartnerTitleData[]>([]);
  const [opbatchs, setOpbatchs] = useState<OpBatchData[]>([]);
  const [opFeesTerms, setOpFeesTerms] = useState<OpFeesTermData[]>([]);
  const [branch, setBranch] = useState<Option>(getUser()?.company_ids[0]?.branches[0]);
  const branches = getUser()?.company_ids[0]?.branches;



  const fetchDataRestPartnerTitle = async () => {

    UserService.getRestPartnerTitle((response: any) => {
      if (response?.data && response?.success) {
        setPartnerTitle(response.data);

      }
    });
  };


  const fetchDataOpBatchs = async (course_id: any) => {
    UserService.getOpBatch(course_id, (response: any) => {
      if (response?.data && response?.success) {
        setOpbatchs(response.data);
      }
    });
  };


  const fetchDataOpFeesTerm = async (company_id: any) => {

    UserService.getOpFeesTerm(company_id, (response: any) => {
      if (response?.data && response?.success) {
        setOpFeesTerms(response.data);
        setIsLoading(false)

      }
    });
  };


  const fetchData = async (admission_id: any) => {
    setIsLoading(true)
    UserService.getApplicationAdmission(admission_id, (response: any) => {
      if (response?.data && response?.success) {
        setAdmissions(response.data);
        console.log(response.data)
        setIsLoading(false)

      } else {
        setIsLoading(false)
      }
    });
  };

  const fetchDataAdmissionDetails = async (admission_id: any) => {
    setIsLoading(true)
    UserService.getOneAdmission(admission_id, (response: any) => {
      if (response?.data && response?.success) {
        setAdmission(response.data[0]);
        console.log(response.data[0])
        setIsLoading(false)

      } else {
        setIsLoading(false)
      }
    });
  };

  useEffect(() => {

    fetchData(admissionId);
    fetchDataAdmissionDetails(admissionId);
    fetchDataRestPartnerTitle()
  }, []);


  const [courses, setCourses] = useState<CourseData[]>([]);

  const fetchDataCourse = async (company_id: any) => {
    UserService.getCourseByBranchAndComapny2(company_id, (response: any) => {
      if (response?.data && response?.success) {
        setCourses(response.data);
      }
    });
  };


  useEffect(() => {
    fetchDataCourse(getUser()?.company_ids[0]?.id);
    fetchDataOpFeesTerm(getUser()?.company_ids[0]?.id);
  }, []);

  const [academyYears, setAcademyYears] = useState<AcademyYearData[]>([]);
  const fetchDataAcademicYear = async (company_id: any) => {
    UserService.getAcademyYear2(company_id, (response: any) => {
      if (response?.data && response?.success) {
        setAcademyYears(response.data);
      }
    });
  };

  useEffect(() => {
    fetchDataAcademicYear(getUser()?.company_ids[0]?.id);

  }, []);


  const [academyTerms, setAcademyTerms] = useState<AcademyTermData[]>([]);

  const fetchDataAcademicTerm = async (company_id: any) => {
    UserService.getAcademyTerm2(company_id, (response: any) => {
      if (response?.data && response?.success) {
        setAcademyTerms(response.data);
      }
    });
  };

  useEffect(() => {
    fetchDataAcademicTerm(getUser()?.company_ids[0]?.id);
  }, []);


  const [coursesFees, setCoursesFees] = useState<CourseFeesData[]>([]);


  const fetchDataCourseFees = async (company_id: any) => {
    UserService.getCourseFees(company_id, (response: any) => {
      if (response?.data && response?.success) {
        setCoursesFees(response.data);
      }
    });
  };

  useEffect(() => {
    fetchDataCourseFees(getUser()?.company_ids[0]?.id);
  }, []);


  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      render: (text: string, record: any, index: number) => (
        <>
          <Link to="#" className="link-primary">
            {record.id}
          </Link>
        </>
      ),
    },

    {
      title: "Application Number",
      dataIndex: "application_number",
      sorter: (a: AdmissionData, b: AdmissionData) => a.application_number.length - b.application_number.length,
    },
    {
      title: "Student",
      dataIndex: "student_id",
      render: (record: any) => (
        <>

          <span className="">

            {record.name}
          </span>


        </>
      ),
      sorter: (a: AdmissionData, b: AdmissionData) =>
        a.student_id.length - b.student_id.length,
    },
    {
      title: "Admission Date",
      dataIndex: "admission_date",
      /* sorter: (a: AdmissionData, b: AdmissionData) =>
        a.admission_date.length - b.admission_date.length, */
    },
    {
      title: "Application Date",
      dataIndex: "application_date",
      /*  sorter: (a: AdmissionData, b: AdmissionData) =>
         a.end_date.length - b.end_date.length, */
    },
    {
      title: "Course",
      dataIndex: "course_id",
      render: (record: any) => (
        <>

          <span className="">

            {record.name}
          </span>


        </>
      ),
      sorter: (a: AdmissionData, b: AdmissionData) =>
        a.course_id.length - b.course_id.length,
    },
    {
      title: "State",
      dataIndex: "state",
      sorter: (a: AdmissionData, b: AdmissionData) =>
        a.state.length - b.state.length,
    },


    {
      title: "Action",

      render: (record: any) => (
        <>
          <div className="d-flex align-items-center">
            <div className="dropdown">
              <Link
                to="#"
                className="btn btn-white btn-icon btn-sm d-flex align-items-center justify-content-center rounded-circle p-0"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="ti ti-dots-vertical fs-14" />
              </Link>
              <ul className="dropdown-menu dropdown-menu-right p-3">
                <li>
                  <Link
                    className="dropdown-item rounded-1"
                    to="#"
                    onClick={() => handleEdit(record)}
                  >
                    <i className="ti ti-edit-circle me-2" />
                    Edit
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item rounded-1"
                    to="#"
                    data-bs-toggle="modal"
                    data-bs-target="#delete-modal"
                  >
                    <i className="ti ti-trash-x me-2" />
                    Delete
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </>
      ),
    },
  ];
  return (
    <div>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Application List</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={route.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="#">Admission </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    All Application
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <TooltipOption />
              <div className="mb-2">
                <Link
                  to="#"
                  className="btn btn-primary"
                  onClick={handleShow}
                >
                  <i className="ti ti-square-rounded-plus-filled me-2" />
                  Application
                </Link>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          {/* Guardians List */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Admission ({admission?.name})</h4>
              <div className="d-flex align-items-center flex-wrap">
                <div className="input-icon-start mb-3 me-2 position-relative">
                  <PredefinedDateRanges />
                </div>
                <div className="dropdown mb-3 me-2">
                  <Link
                    to="#"
                    className="btn btn-outline-light bg-white dropdown-toggle"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="outside"
                  >
                    <i className="ti ti-filter me-2" />
                    Filter
                  </Link>
                  <div className="dropdown-menu drop-width" ref={dropdownMenuRef}>
                    <form >
                      <div className="d-flex align-items-center border-bottom p-3">
                        <h4>Filter</h4>
                      </div>
                      <div className="p-3 border-bottom pb-0">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="mb-3">
                              <label className="form-label">Admission</label>
                              <CommonSelect
                                className="select"
                                options={classSylabus}
                                defaultValue={classSylabus[0]}
                              />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="mb-3">
                              <label className="form-label">Section</label>
                              <CommonSelect
                                className="select"
                                options={classSection}
                                defaultValue={classSection[0]}
                              />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="mb-3">
                              <label className="form-label">Status</label>
                              <CommonSelect
                                className="select"
                                options={activeList}
                                defaultValue={activeList[0]}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="p-3 d-flex align-items-center justify-content-end">
                        <Link to="#" className="btn btn-light me-3">
                          Reset
                        </Link>
                        <Link
                          to="#"
                          className="btn btn-primary"
                          onClick={handleApplyClick}
                        >
                          Apply
                        </Link>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="dropdown mb-3">
                  <Link to="#" className="btn btn-outline-light bg-white dropdown-toggle" data-bs-toggle="dropdown">
                    <i className="ti ti-sort-ascending-2 me-2" />
                    {branch?.name}
                  </Link>
                  {/*      <ul className="dropdown-menu p-3">
                    {branches.map((item: any) => (
                      <li key={item.id}>
                        <a className="dropdown-item rounded-1" onClick={() => fetchData(item.id, getUser().company_ids[0].id, item)}>
                          {item.name}
                        </a>
                      </li>
                    ))}
                  </ul> */}
                </div>

              </div>
            </div>

            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-3">

              <div className="mb-2 ">
                {admission?.state === "draft" && (
                  <>
                    <a className="btn btn-primary mx-2" href="#">Confirm</a>

                    <a className="btn btn-light mr-2" href="#">Cancel</a>
                  </>

                )
                }

                {admission?.state === "confirm" && (
                  <>
                    <a className="btn btn-primary mx-2" href="#">Start Application</a>

                    <a className="btn btn-light mr-2" href="#">Cancel</a>
                  </>

                )
                }

                {admission?.state === "application" && (
                  <>
                    <a className="btn btn-primary mx-2" href="#">Start Admission</a>
                  </>

                )
                }

                {admission?.state === "admission" && (
                  <>
                    <a className="btn btn-primary mx-2" href="#">Done</a>
                  </>

                )
                }

              </div>
              <div className="d-flex align-items-center flex-wrap">
                <div className="breadcrumb-design flat-design">
                  {admission?.state === "draft" ? (<a href="#" className="active">Draft</a>) : <a href="#" >Draft</a>}
                  {admission?.state === "confirm" ? (<a href="#" className="active">Confirmed</a>) : <a href="#" >Confirmed</a>}
                  {admission?.state === "application" ? (<a href="#" className="active">Application Gathering</a>) : <a href="#" >Application Gathering</a>}
                  {admission?.state === "admission" ? (<a href="#" className="active">Admission Process</a>) : <a href="#" >Admission Process</a>}
                  {admission?.state === "done" ? (<a href="#" className="active">Done</a>) : ""}

                </div>

              </div>

              <div className="mt-4 col-sm-12">
                <div className="student-leave-info student-leave-info-design-info">
                  <ul>
                    <li><span>Name</span>
                      <h6>{admission?.name}</h6>
                    </li>
                    <li><span>Course</span>
                      <h6>{admission?.course_id[0]?.name}</h6>
                    </li>
                    <li><span>Start Date</span>
                      <h6>{admission?.start_date}</h6>
                    </li>
                    <li><span>End Date</span>
                      <h6>{admission?.end_date}</h6>
                    </li>
                    <li><span>Maximum No. of Admission</span>
                      <h6>{admission?.max_count}</h6>
                    </li>
                    <li><span>Minimum No. of Admission</span>
                      <h6>{admission?.min_count}</h6>
                    </li>
                    <li><span>Course Fees</span>
                      <h6>{admission?.product_id[0].name}</h6>
                    </li>
                    <li><span>Company</span>
                      <h6>{admission?.company_id[0]?.name}</h6>
                    </li>
                    <li><span>Minimum Required Age(Years)</span>
                      <h6>{admission?.minimum_age_criteria}</h6>
                    </li>
                    <li><span>Branch</span>
                      <h6>{admission?.operating_branch_id[0]?.name}</h6>
                    </li>
                    <li><span>Terms</span>
                      <h6>{admission?.academic_term_id[0]?.name}</h6>
                    </li>
                    <li><span>Academic Year</span>
                      <h6>{admission?.academic_years_id[0]?.name}</h6>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0 py-3">
              {/* Guardians List */}

              {Admissions.length > 0 ? (
                <Table columns={columns} dataSource={Admissions} Selection={true} />

              ) : (
                <div className="col-md-12 text-center">
                  {
                    isLoading ? (<Link to="#" className="btn btn-primary">
                      <span
                        className="spinner-border spinner-border-sm align-middle me-1"
                        role="status"
                        aria-hidden="true"
                      />
                      Load More ...
                    </Link>) : (<Link to="#" className="btn btn-primary">
                      <i className="ti ti-loader-3 me-2" />
                      Load More
                    </Link>)
                  }
                </div>
              )}
              {/* /Guardians List */}
            </div>
          </div>
          {/* /Guardians List */}
        </div>
      </div>
      ;{/* /Page Wrapper */}
      <>

        {/* Delete Modal */}
        <div className="modal fade" id="delete-modal">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <form >
                <div className="modal-body text-center">
                  <span className="delete-icon">
                    <i className="ti ti-trash-x" />
                  </span>
                  <h4>Confirm Deletion</h4>
                  <p>
                    You want to delete all the marked items, this cant be undone
                    once you delete.
                  </p>
                  <div className="d-flex justify-content-center">
                    <Link
                      to="#"
                      className="btn btn-light me-3"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <Link to="#" className="btn btn-danger" data-bs-dismiss="modal"
                    >
                      Yes, Delete
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Delete Modal */}
        {/* View Classes */}
        <div className="modal fade" id="view_class">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <div className="d-flex align-items-center">
                  <h4 className="modal-title">Admission Details</h4>
                  <span className="badge badge-soft-success ms-2">
                    <i className="ti ti-circle-filled me-1 fs-5" />
                    Active
                  </span>
                </div>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form >
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="class-detail-info">
                        <p>Admission Name</p>
                        <span>III</span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="class-detail-info">
                        <p>Section</p>
                        <span>A</span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="class-detail-info">
                        <p>No of Subjects</p>
                        <span>05</span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="class-detail-info">
                        <p>No of Students</p>
                        <span>25</span>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /View Classes */}



        <div className="modal fade" id="delete-modal">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <form >
                <div className="modal-body text-center">
                  <span className="delete-icon">
                    <i className="ti ti-trash-x" />
                  </span>
                  <h4>Confirm Deletion</h4>
                  <p>
                    You want to delete all the marked items, this cant be undone
                    once you delete.
                  </p>
                  <div className="d-flex justify-content-center">
                    <Link
                      to="#"
                      className="btn btn-light me-3"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <Link to="#" className="btn btn-danger" data-bs-dismiss="modal"
                    >
                      Yes, Delete
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Delete Modal */}
        {/* View Classes */}
        <div className="modal fade" id="view_class">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <div className="d-flex align-items-center">
                  <h4 className="modal-title">Admission Details</h4>
                  <span className="badge badge-soft-success ms-2">
                    <i className="ti ti-circle-filled me-1 fs-5" />
                    Active
                  </span>
                </div>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form >
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="class-detail-info">
                        <p>Admission Name</p>
                        <span>III</span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="class-detail-info">
                        <p>Section</p>
                        <span>A</span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="class-detail-info">
                        <p>No of Subjects</p>
                        <span>05</span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="class-detail-info">
                        <p>No of Students</p>
                        <span>25</span>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /View Classes */}



        <Modal show={showModal} onHide={handleClose} size={"xl"}>
          <Modal.Header >
            <Modal.Title>Add Application</Modal.Title>
            <button
              type="button"
              className="btn-close custom-btn-close"
              onClick={handleClose}

            >
              <i className="ti ti-x" />
            </button>
          </Modal.Header>
          <Modal.Body>
            <form>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="d-flex align-items-center flex-wrap row-gap-3 mb-3">
                      <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                        <i className="ti ti-photo-plus fs-16" />
                      </div>
                      <div className="profile-upload">
                        <div className="profile-uploader d-flex align-items-center">
                          <div className="drag-upload-btn mb-3">
                            Upload
                            <input
                              type="file"
                              className="form-control image-sign"
                              multiple
                            />
                          </div>
                          <Link to="#" className="btn btn-primary mb-3">
                            Remove
                          </Link>
                        </div>
                        <p className="fs-12">
                          Upload image size 4MB, Format JPG, PNG, SVG
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">

                  <div className="col-md-3">
                    <div className="mb-3">
                      <label className="form-label">Title</label>
                      <select

                        className="select react-select form-control"
                        name="academic_years_id"
                        onChange={handleInputChange}
                      >
                        <option >Select Title</option>
                        {partnerTitle && partnerTitle?.map((item: any) => (
                          <option key={item.id} value={item.id}>{item.name}</option>
                        ))}

                      </select>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="mb-3">
                      <label className="form-label">First Name</label>
                      <input type="text" className="form-control" placeholder="Name" name="name" value={formData.name}
                        onChange={handleInputChange} />
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="mb-3">
                      <label className="form-label">Middle Name</label>
                      <input type="text" className="form-control" placeholder="Name" name="name" value={formData.name}
                        onChange={handleInputChange} />
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="mb-3">
                      <label className="form-label">Last Name</label>
                      <input type="text" className="form-control" placeholder="Name" name="name" value={formData.name}
                        onChange={handleInputChange} />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label">Gender</label>
                      <select

                        className="select react-select form-control"
                        name="gender"
                        onChange={handleInputChange}
                      >
                        <option >Select Gender</option>

                        <option value="m">Male</option>
                        <option value="f">Female</option>


                      </select>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label">Email</label>
                      <input type="email" className="form-control" name="email"
                        //  value={formData.email}
                        onChange={handleInputChange} placeholder="Email" />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label">Birth Date</label>
                      <input type="date" className="form-control" name="birth_date"
                        //value={formData.birth_date}
                        onChange={handleInputChange} placeholder="Birth date" />
                    </div>


                  </div>


                </div>


                <div className="row">
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label">	Course</label>
                      <select

                        className="select react-select form-control"
                        name="course_id"
                        onChange={handleInputChange}
                      >
                        <option >Select Course</option>
                        {courses && courses?.map((item: any) => (
                          <option key={item.id} value={item.id}>{item.name}</option>
                        ))}

                      </select>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label">Application Date</label>
                      <DatePicker
                        className="form-control datetimepicker"
                        format={{
                          format: "DD-MM-YYYY",
                          type: "mask",
                        }}
                        defaultValue=""
                        placeholder="Select Date"
                      />

                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label">Admission Date</label>
                      <DatePicker
                        className="form-control datetimepicker"
                        format={{
                          format: "DD-MM-YYYY",
                          type: "mask",
                        }}
                        defaultValue=""
                        placeholder="Select Date"
                      />
                      <span className="input-icon-addon">
                        <i className="ti ti-calendar" />
                      </span>
                    </div>
                  </div>
                </div>


                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">	Fees Term</label>
                      <select

                        className="select react-select form-control"
                        name="course_id"
                        onChange={handleInputChange}
                      >
                        <option >Select Fees Term</option>
                        {opFeesTerms && opFeesTerms?.map((item: any) => (
                          <option key={item.id} value={item.id}>{item.name}</option>
                        ))}

                      </select>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">	Batch</label>
                      <select

                        className="select react-select form-control"
                        name="course_id"
                        onChange={handleInputChange}
                      >
                        <option >Select Batch</option>
                        {opbatchs && opbatchs?.map((item: any) => (
                          <option key={item.id} value={item.id}>{item.name}</option>
                        ))}

                      </select>
                    </div>
                  </div>
                </div>



              </div>
              <div className="modal-footer">
                <span
                  className="btn btn-light me-2"
                  onClick={handleClose}
                >
                  Cancel
                </span>
                <a className="btn btn-primary"  >
                  {isLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm align-middle me-1"
                        role="status"
                        aria-hidden="true"
                      />
                      Loading...
                    </>
                  ) : "Add Application"}

                </a>
              </div>
            </form>
          </Modal.Body>

        </Modal>

        <Modal show={showModal2} onHide={handleClose2} >
          <Modal.Header >
            <Modal.Title>Edit Admission</Modal.Title>
            <button
              type="button"
              className="btn-close custom-btn-close"
              onClick={handleClose2}

            >
              <i className="ti ti-x" />
            </button>
          </Modal.Header>
          <Modal.Body>
            <form>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">Name</label>
                      <input type="text" className="form-control" placeholder="Name" name="name" value={selectedRecord?.name}
                        onChange={handleInputChangeEdite} />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Start data</label>
                      <input type="date" className="form-control" name="start_date"
                        value={formatDate(selectedRecord?.start_date)}
                        onChange={handleInputChangeEdite} />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">End date</label>
                      <input type="date" className="form-control" name="end_date"
                        value={formatDate(selectedRecord?.end_date)}
                        onChange={handleInputChangeEdite} />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">	Course</label>
                      <select

                        className="select react-select form-control"
                        name="course_id"
                        value={selectedRecord.course_id?.[0]?.id}
                        onChange={handleInputChangeEdite}
                      >
                        <option >Select Course</option>
                        {courses && courses?.map((item: any) => (
                          <option key={item.id} value={item.id}>{item.name}</option>
                        ))}

                      </select>
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Course Fees</label>
                      <select

                        className="select react-select form-control"
                        name="product_id"
                        value={selectedRecord.product_id?.[0]?.id}
                        onChange={handleInputChangeEdite}
                      >
                        <option >Select Course fees</option>
                        {coursesFees && coursesFees?.map((item: any) => (
                          <option key={item.id} value={item.id}>{item.name}</option>
                        ))}

                      </select>
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Branch</label>
                      <select
                        className="select react-select form-control"
                        name="operating_branch_id"
                        value={selectedRecord?.operating_branch_id?.[0]?.id || ''}// Assurez-vous que cette valeur correspond à une option
                        onChange={handleInputChangeEdite2}
                      >
                        {branches && branches.map((item: any) => (
                          <option value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>

                    </div>


                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <span
                  className="btn btn-light me-2"
                  onClick={handleClose2}
                >
                  Cancel
                </span>
                <Link to="#" className="btn btn-primary" >
                  {isLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm align-middle me-1"
                        role="status"
                        aria-hidden="true"
                      />
                      Loading...
                    </>
                  ) : "Edit Admission"}

                </Link>
              </div>
            </form>
          </Modal.Body>

        </Modal>

        <Toast
          show={showDangerToast}
          onClose={handleDangerToastClose}
          id="dangerToast"
          className="toast-container position-fixed top-0 end-0 p-3 colored-toast bg-danger-transparent"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
          style={{ minWidth: "200px!important" }}
        >
          <Toast.Header closeButton className="bg-danger text-fixed-white">
            <strong className="me-auto">Message</strong>
            <span
              className="cursor-pointer"
              onClick={handleDangerToastClose}
              aria-label="Close"
              style={{ cursor: "pointer" }}
            />
          </Toast.Header>
          <Toast.Body>
            {/* Add your toast content here */}
            {errorMessage}
          </Toast.Body>
        </Toast>

        <Toast
          show={showSuccessToast}
          onClose={handleSuccessToastClose}
          id="successToast"
          className="toast-container position-fixed top-0 end-0 p-3  colored-toast bg-success-transparent"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
        >

          <Toast.Body>
            {/* Add your toast content here */}
            {successMessage}
          </Toast.Body>
        </Toast>
      </>
    </div >
  );
};

export default Application;
